import { render, staticRenderFns } from "./OnboardingHeight.vue?vue&type=template&id=517d3832&scoped=true&"
import script from "./OnboardingHeight.vue?vue&type=script&lang=js&"
export * from "./OnboardingHeight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517d3832",
  null
  
)

export default component.exports